import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdvancedModelSettingsService {
  private readonly storageKey = 'globalAdvancedTranslationModelEnabled';
  private readonly globalAdvancedModelSubject = new BehaviorSubject<boolean>(
    this.loadInitialValue()
  );

  readonly globalAdvancedModel$ =
    this.globalAdvancedModelSubject.asObservable();

  isGlobalAdvancedModelEnabled(): boolean {
    return this.globalAdvancedModelSubject.value;
  }

  setGlobalAdvancedModelEnabled(enabled: boolean): void {
    this.globalAdvancedModelSubject.next(enabled);
    try {
      localStorage.setItem(this.storageKey, String(enabled));
    } catch (error) {
      console.warn(
        '[AdvancedModelSettings] Could not persist global setting:',
        error
      );
    }
  }

  getEffectiveUseAdvancedModel(localEnabled: boolean): boolean {
    return this.isGlobalAdvancedModelEnabled() || localEnabled;
  }

  private loadInitialValue(): boolean {
    try {
      return localStorage.getItem(this.storageKey) === 'true';
    } catch {
      return false;
    }
  }
}
